import { render, staticRenderFns } from "./CustomerInformation.vue?vue&type=template&id=34e55308&"
import script from "./CustomerInformation.vue?vue&type=script&lang=ts&"
export * from "./CustomerInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports